import React, { useCallback, useEffect, useState } from "react";
import { PrinteSku4x3 } from "./print/PrinteSku4x3";
import {
  Box,
  Button,
  ButtonGroup,
  Checkbox,
  DataTable,
  Divider,
  Layout,
  LegacyStack,
  Page,
  TextField,
} from "@shopify/polaris";
import {
  LoadProductWithSKU,
  ProductSelectedProp,
} from "src/components/shopify/products/quick_product/LoadProductWithSKU";
import { useHistory } from "react-router";
import { PolarisCard } from "src/components/shopify/PolarisCard";
import { ProductListType, useProductListV2LazyQuery } from "src/graphql/codegen_graphql";
import { useTranslation } from "react-i18next";
import moment from "moment";

export function InventorySkuScreen() {
  const { t } = useTranslation();
  const history = useHistory();
  const [selectSku, setSelectSku] = useState(0);
  const [selectProduct, setSelectProduct] = useState<ProductSelectedProp[]>([]);
  const [products, setProducts] = useState<any[]>([]);
  const [productQuery] = useProductListV2LazyQuery();
  const [count, setCount] = useState(0);
  const [batch, setBatch] = useState(1);
  const [withoutPrice, setWithoutPrice] = useState(false);
  const [expiredDate, setExpiredDate] = useState(moment().format("YYYY-MM-DD"));
  const [withExpiredDate, setWithExpiredDate] = useState(false);
  let refPrint4x3: HTMLButtonElement;

  useEffect(() => {
    const query = new URLSearchParams(history.location.search);
    const id = Number(query.get("id"));
    const skuid = Number(query.get("sku_id"));
    setSelectSku(skuid ? skuid : 0);
    if (id > 0) {
      setSelectProduct([{ id, sku: [] }]);
      productQuery({
        variables: {
          productListType: ProductListType.Approved,
          search: {
            id,
          },
        },
      }).then((res) => {
        if (res.data?.productListV2) {
          setProducts(
            res.data.productListV2.data?.map((x) => {
              return {
                product: x,
                sku: x?.skuList,
              };
            }) || [],
          );
        }
      });
    }
  }, [history, productQuery]);

  const handleSelectProduct = useCallback(
    (v) => {
      const query = new URLSearchParams(history.location.search);
      query.set("id", v[0].id + "");
      query.set("sku_id", v[0].sku[0]);
      setSelectSku(v[0].sku[0]);
      history.replace({
        pathname: history.location.pathname,
        search: query.toString(),
      });
      setSelectProduct(v);
    },
    [history],
  );

  const sku = products.length > 0 ? products[0].sku.find((f: any) => f.id === selectSku) : null;

  return (
    <Page title="Create Barcode">
      <Layout>
        <Layout.Section>
          <PolarisCard padding={"0"} roundedAbove="sm">
            <Box padding={"500"}>
              <LoadProductWithSKU
                initialProductSelected={selectProduct}
                onProductSelectedChange={handleSelectProduct}
                onLoadProductInfo={setProducts}
                productOnly
                singleSelect
              />
            </Box>
            {products.length > 0 && (
              <Box>
                <div style={{ display: "flex" }}>
                  <img
                    src={String(products[0].product.picture).replace("w=100", "w=600").replace("h=100", "h=600")}
                    alt=""
                    style={{ width: 250, objectFit: "cover", height: "fit-contain" }}
                  />
                  <div className="ml-3 pr-3">
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                      <TextField
                        readOnly
                        value={products[0].product.code}
                        label={t("product_code")}
                        autoComplete="off"
                      />
                      <div className="ml-2 mr-2">
                        <TextField
                          suffix="USD"
                          readOnly
                          value={products[0].product.price}
                          label={t("price")}
                          autoComplete="off"
                        />
                      </div>
                      <TextField
                        readOnly
                        suffix="%"
                        value={products[0].product.discount}
                        label={t("discount")}
                        autoComplete="off"
                      />
                    </div>
                    <br />
                    <Divider borderWidth="100" borderColor="border" />
                    <br />
                    {sku && (
                      <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <div style={{ width: "49.3%" }}>
                          <TextField readOnly value={sku.option1} label={t("color")} autoComplete="off" />
                        </div>
                        <div style={{ width: "49.3%" }}>
                          <TextField readOnly value={sku.option2} label={t("size")} autoComplete="off" />
                        </div>
                      </div>
                    )}
                    <br />
                    {sku && (
                      <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <div style={{ width: "49.3%" }}>
                          <TextField readOnly value={sku.barcode} label={t("barcode")} autoComplete="off" />
                        </div>
                        <div style={{ width: "49.3%" }}>
                          <TextField
                            readOnly
                            value={sku.barcodeOriginal}
                            label={t("original_barcode")}
                            autoComplete="off"
                          />
                        </div>
                      </div>
                    )}
                    <br />
                    <Divider borderWidth="100" borderColor="border" />
                    <br />
                    <Checkbox checked={withoutPrice} onChange={(v) => setWithoutPrice(v)} label="Print without price" />
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                      <Checkbox
                        checked={withExpiredDate}
                        onChange={(v) => setWithExpiredDate(v)}
                        label="Expired Date"
                      />
                      <div className="ml-2">
                        <TextField
                          disabled={!withExpiredDate}
                          type="date"
                          label=""
                          autoComplete="off"
                          value={expiredDate}
                          onChange={setExpiredDate}
                        />
                      </div>
                    </div>
                    <br />
                    <br />
                    <LegacyStack alignment="center">
                      <LegacyStack.Item>Printing Counter</LegacyStack.Item>
                      <LegacyStack.Item fill>
                        <TextField
                          readOnly
                          labelHidden
                          label="Printing Counter"
                          // align="right"
                          autoComplete="off"
                          value={count + ""}
                          connectedRight={
                            <ButtonGroup variant="segmented">
                              <Button
                                variant="primary"
                                tone="success"
                                onClick={() => {
                                  setCount(count + batch);
                                  refPrint4x3.click();
                                }}
                              >
                                Print Barcode
                              </Button>
                              <Button
                                variant="primary"
                                onClick={() => {
                                  const pro = window.prompt("How many barcode you want to print?");
                                  if (Number(pro) > 0) {
                                    setBatch(Number(pro));
                                  }
                                }}
                              >
                                Print Many
                              </Button>
                            </ButtonGroup>
                          }
                        />
                      </LegacyStack.Item>
                    </LegacyStack>
                    <br />
                  </div>
                </div>
                {!!sku && (
                  <div style={{ position: "fixed", top: -9999 }}>
                    <PrinteSku4x3
                      sku={[...new Array(batch)].map(() => {
                        return {
                          code: products[0].product.code,
                          price: withoutPrice
                            ? ""
                            : (
                                Number(products[0].product.price) -
                                Number(products[0].product.price) * (Number(products[0].product.discount) / 100)
                              ).toFixed(2),
                          sku: [
                            {
                              sku_id: sku.id,
                              color: sku.option1,
                              size: sku.option2,
                              expiredDate: withExpiredDate ? expiredDate : undefined,
                            },
                          ],
                        };
                      })}
                      refPrint={(ref: any) => (refPrint4x3 = ref)}
                    />
                  </div>
                )}
              </Box>
            )}
          </PolarisCard>
        </Layout.Section>
        <Layout.Section variant="oneThird">
          {products.length > 0 && (
            <PolarisCard padding={"0"} roundedAbove="sm">
              <Box>
                <DataTable
                  headings={[t("barcode"), t("color"), t("size")]}
                  columnContentTypes={["text", "text", "text"]}
                  rows={products[0].sku.map((x: any) => {
                    return [
                      <Button
                        onClick={() => {
                          const query = new URLSearchParams(history.location.search);
                          query.set("sku_id", x.barcode);
                          setSelectSku(Number(x.barcode));
                          history.replace({
                            pathname: history.location.pathname,
                            search: query.toString(),
                          });
                        }}
                        variant={selectSku !== Number(x.barcode) ? "plain" : "primary"}
                        size="slim"
                        disabled={selectSku === Number(x.barcode)}
                      >
                        {x.barcode}
                      </Button>,
                      x.option1,
                      x.option2,
                    ];
                  })}
                  truncate
                />
              </Box>
            </PolarisCard>
          )}
        </Layout.Section>
      </Layout>
    </Page>
  );
}
